module.exports = __webpack_public_path__ + "halle_der_runen_karten_banner_2_600x398.jpg?7b3ba524646586ad0650432ca3dc6dad";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/halle_der_runen_karten_banner_2_600x398.jpg
// module id = 77
// module chunks = 0